import useAuth from 'hooks/useAuth';
import useCommonStore from 'hooks/useCommonStore';
import { isEmpty } from 'lodash';
import React, { useEffect } from 'react';
import { PII_PROFILE_PENDING_PII_STATUS } from '../const';
import usePII from '../hooks/usePII';

const withShowPIIVerifyNowModal = (Component) => {
  const ShowPIIVerifyNowModalComponent = (props) => {
    const { currentUser } = useCommonStore();
    const { handleShowPIIVerifyNowModal } = usePII();
    const { token } = useAuth();

    useEffect(() => {
      if (!token) return;
      if (isEmpty(currentUser)) return;
      const { status: profileStatus } = currentUser || {};
      if (profileStatus === PII_PROFILE_PENDING_PII_STATUS) {
        handleShowPIIVerifyNowModal();
      }
    }, [token, currentUser]);

    const newProps = {
      ...props,
    };
    return <Component {...newProps} />;
  };
  return ShowPIIVerifyNowModalComponent;
};

export default withShowPIIVerifyNowModal;
